"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Svg = void 0;
var _index = require("../../styles/index.js");
var _index2 = require("./index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var graphicSizeMap = {
  xsmall: 'smaller-2',
  small: 'smaller',
  medium: 'base',
  large: 'larger',
  xlarge: 'larger-3',
  xxlarge: 'larger-4'
};

/* Now that width and height are defined in css
   we need to listen for width and height attributes
   and apply them, with units, when they are present
*/
var attrToStyle = function attrToStyle(attr) {
  // check if attr aleady has units
  var hasUnits = isNaN(Number(attr));
  // append px only if needed
  return hasUnits ? attr : "".concat(attr, "px");
};
var Svg = exports.Svg = _styledComponents["default"].svg.withConfig({
  displayName: "Svg",
  componentId: "sc-ytk21e-0"
})(["*{vector-effect:non-scaling-stroke;}", " ", " width:", ";height:", ";"], function (props) {
  return props.$autoMirror && (0, _styledComponents.css)(["[dir='rtl'] &&{transform:scaleX(-1);}"]);
}, function (props) {
  return props.$iconColor ? (0, _styledComponents.css)(["fill:", ";"], (0, _index.cssColorValue)(props.$iconColor)) : (0, _styledComponents.css)(["fill:currentcolor;"]);
}, function (_ref) {
  var $width = _ref.$width,
    $size = _ref.$size,
    _ref$$tokenType = _ref.$tokenType,
    $tokenType = _ref$$tokenType === void 0 ? 'decorative' : _ref$$tokenType;
  return $width ? attrToStyle($width) : (0, _index.cssGraphicSize)(graphicSizeMap[$size], $tokenType, "".concat(_index2.IconSizeMap[$size], "px"));
}, function (_ref2) {
  var $height = _ref2.$height,
    $size = _ref2.$size,
    _ref2$$tokenType = _ref2.$tokenType,
    $tokenType = _ref2$$tokenType === void 0 ? 'decorative' : _ref2$$tokenType;
  return $height ? attrToStyle($height) : (0, _index.cssGraphicSize)(graphicSizeMap[$size], $tokenType, "".concat(_index2.IconSizeMap[$size], "px"));
});